<template>
    <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
        <div id="fullscreen-loader" v-if="loading">
            <img src="@/assets/logo.png"/>
        </div>
        <side-bar :title="$store.state.props.appName" :data-mobile-visible="mobileVisible" @close="toggleSidebar">
            <template slot="links">
                <user-menu :title="user.name"></user-menu>
                <div class="event-info">
                    <div class="d-flex justify-content-center flex-wrap">
                        <img
                            v-if="event.logo && event.logo._id"
                            :src="$store.state.baseUrl + event.logo.path"
                            height="90px"/>
                        <div class="w-100">    
                            <h2>{{ event.name }}</h2>
                            <p>From <span>{{ event.startDate | date }}</span> To <span>{{ event.endDate | date }}</span></p>
                        </div>
                    </div>
                </div>
                <sidebar-item :link="{ name: 'website', icon: 'now-ui-icons design_app', path: `/evt/${$route.params.eventId}` }" title="External"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['viewDashboard'])" :link="{ name: 'dashboard', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}` }"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['viewUsers'])" :link="{ name: 'users', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/users` }" title="Users"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['viewRegistrants'])" :link="{ name: 'attendees', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/attendees` }" title="Registrants"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['checkinActivities'])" :link="{ name: 'activities', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/activities` }" title="Activities"/>
                <sidebar-item v-if="user.admin || user._id" :link="{ name: 'checkpoints', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/checkpoints` }" title="checkpoints"/>
                <sidebar-item v-if="user.admin || user._id" :link="{ name: 'checkpointfields', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/checkpointfields` }" title="checkpoint fields"/>
                <sidebar-item v-if="user.admin || user._id" :link="{ name: 'checkpointfields-data', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/checkpointfields-data` }" title="checkpoint fields data"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['viewRegistrationTypes'])" :link="{ name: 'registration-types', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/registration-types` }" title="Registration Types"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['editRegistrationTypes'])" :link="{ name: 'registration-type-groups', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/registration-type-groups` }" title="Registration Type Groups"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['viewReports'])" title="Reports" :link="{ name: 'reports', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/reports` }"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['downloadStandaloneReports'])" title="Standalone Reports" :link="{ name: 'standalone-reports', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/standalone-reports` }"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['viewCustomFields'])" :link="{ name: 'custom-fields', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/custom-fields` }" title="Custom Fields"/>
                <sidebar-item v-if="user.admin" :link="{ name: 'user-activity', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/user-activity` }" title="Log"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['sendMassEmails'])" :link="{ name: 'mass-emails-log', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/mass-emails-log` }" title="Mass Emails Log"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['sendMassTexts'])" :link="{ name: 'mass-text-log', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/mass-text-log` }" title="Mass Text Log"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['accessToTemplates'])" :link="{ name: 'templates', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/templates` }" title="Templates"/>
                <sidebar-item v-if="user.admin || userHasPermissions(['settings'])" :link="{ name: 'settings', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/settings` }"/>
                <sidebar-item v-if="user.admin" :link="{ name: 'file-uploads', icon: 'now-ui-icons design_app', path: `/dashboard/${$route.params.eventId}/uploads` }" title="Uploads"/>
            </template>
        </side-bar>

        <div class="main-panel d-flex flex-wrap">
            <navbar :transparent="false">
                <div class="navbar-wrapper">
                    <el-button
                        class="mr-2 d-block d-lg-none"
                        @click="toggleSidebar()">
                            <fa icon="bars"/>
                    </el-button>
                    <router-link
                        class="navbar-brand"
                        :to="{ name: 'events' }">
                            All Events 
                    </router-link>
                </div>
            </navbar>

            <router-view name="header"></router-view>

            <div v-if="!loading" :class="{content: !$route.meta.hideContent}" class="w-100">
                <zoom-center-transition :duration="200" mode="out-in">
                    <router-view></router-view>
                </zoom-center-transition>
            </div>

            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>

<script>
/*  eslint-disable no-new  */
import { ZoomCenterTransition } from 'vue2-transitions'
import { mapState } from 'vuex'
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import ContentFooter from '@/components/layout/ContentFooter.vue'
import UserMenu from '@/components/layout/Extra/UserMenu.vue'
import { Navbar } from '@/components/now-ui'
import moment from 'moment'
import router from '../router'

function hasElement (className) {
    return document.getElementsByClassName(className).length > 0
}

function initScrollbar (className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`)
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className)
        }, 100)
    }
}

export default {
    components: {
        ContentFooter,
        UserMenu,
        ZoomCenterTransition,
        Navbar
    },
    computed: {
        ...mapState(['user', 'event'])
    },
    data () {
        return {
            mobileVisible: false,
            loading: false
        }
    },
    mounted () {
        let docClasses = document.body.classList
        let isWindows = navigator.platform.startsWith('Win')
        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            initScrollbar('sidebar')
            initScrollbar('sidebar-wrapper')

            docClasses.add('perfect-scrollbar-on')
        } else {
            docClasses.add('perfect-scrollbar-off')
        }

        router.beforeEach((to, from, next) => {
            if (this.mobileVisible) {
                this.toggleSidebar()
            }

            next()
        })

        this.getData()
    },
    methods: {
        userHasPermissions(permissions) {
            if (this.user.admin) return true;
            const roles = this.event.adminRoles && this.user._id && this.event.adminRoles[this.user._id] ? this.event.adminRoles[this.user._id] : []
            let valid = true
            permissions.forEach(per => {
                if (!roles[per]) valid = false;
            })
            return valid;
        },
        toggleSidebar: function () {
            this.mobileVisible = !this.mobileVisible
        },
        getData: async function () {
            this.loading = true
            try {
                await Promise.all([
                    this.$store.dispatch('getUser'),
                    this.$store.dispatch('get', { path: 'events', key: 'event', id: this.$route.params.eventId })
                ])
            } catch (e) {
                this.$notify({ type: 'danger', message: 'Unauthorized!' })
                this.$router.push({ name: 'login' })
            }
            this.loading = false
        }
    },
    filters: {
        date: (value) => moment(value).format('MMMM DD, YYYY')
    }
}
</script>

<style lang="scss">
    $scaleSize: .95;

    @keyframes zoomIn95 {
        from {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }

        to {
            opacity: 1;
        }
    }

    .main-panel .zoomIn {
        animation-name: zoomIn95;
    }

    .sidebar-wrapper {
        .event-info {
            padding: 10px;
            color: white;
            text-align: center;

            h2 {
                margin: 0;
                font-size: 20px;
            }

            p {
                font-size: 13px;
                white-space: normal !important;
                line-height: 20px !important;

                span {
                    font-weight: bold;
                }
            }
        }
    }

    .sidebar .logo {
        button {
            position: absolute;
            top: 12px;
            right: 10px;
        }
    }

    @keyframes zoomOut95 {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
    }

    .main-panel .zoomOut {
        animation-name: zoomOut95;
    }
</style>
